import { Helper } from "_utils";
import { PresetDateRange } from "components/admin/autotrade/filters/PresetDateRangeFilter";
import { IAutoTrade, StockHelper } from "predictagram-lib";

export type Comparator = (a: IAutoTrade,b: IAutoTrade, currentDirection: "asc" | "desc") => number
export type TableColumn = {
  name: string | undefined, 
  title: string, 
  comparator?: Comparator | undefined
}

export interface ISortColumn {
  tableColumn: TableColumn,
  direction: "asc" | "desc",
}


export class TradeModel {

  static compareHelper (a: string | number, b: string | number, currentDirection: "asc" | "desc")  {

    if (a.toString() === "" || a.toString() === "undefined") {
      return 1;
    }

    if (b.toString() === "" || b.toString() === "undefined") {
      return -1;
    }
 

    const result = a.toString().localeCompare(b.toString(), 'en-US', {numeric: true});
    if (result < 0) {
      return currentDirection === "asc" ? -1 : 1;
    }
  
    if (result > 0) {
      return currentDirection === "asc" ? 1 : -1;
    }
    return 0;  
  }

  static tradeListTableColumns: TableColumn[] =  [
    ['id', 'ID', undefined],
    ['setupName', 'Trade Setup Name', undefined],
    ['security', 'Security', (a: IAutoTrade, b: IAutoTrade, currentDirection: "asc" | "desc") => {
      const valueA = `${a.ibkrOpenOrder?.orderSide} ${a.ibkrOpenOrder?.optionName}`;
      const valueB = `${b.ibkrOpenOrder?.orderSide} ${b.ibkrOpenOrder?.optionName}`;
      return TradeModel.compareHelper(valueA, valueB, currentDirection)
    }],
    ['positionTypeId', 'Position Type',undefined],
    ['openQuantity', 'Quantity', undefined],
    ['openPrice', 'Open Price', (a: IAutoTrade, b: IAutoTrade, currentDirection: "asc" | "desc") => {
      const valueA = `${a.ibkrOpenOrder?.orderPrice}`;
      const valueB = `${b.ibkrOpenOrder?.orderPrice}`;
      return TradeModel.compareHelper(valueA, valueB, currentDirection)
    }],
    ['closePrice', 'Close Price', (a: IAutoTrade, b: IAutoTrade, currentDirection: "asc" | "desc") => {
      const valueA = `${a.ibkrCloseOrder?.orderPrice}`;
      const valueB = `${b.ibkrCloseOrder?.orderPrice}`;
      return TradeModel.compareHelper(valueA, valueB, currentDirection)
    }],
    ['openAt', 'Opened On', undefined],
    [undefined, 'Trade', undefined],
    ['livePrice', 'Current Price', (a: IAutoTrade, b: IAutoTrade, currentDirection: "asc" | "desc") => {
      const valueA = `${(a as any).livePrices?.lastPrice}`;
      const valueB = `${(b as any).livePrices?.lastPrice}`;
      return TradeModel.compareHelper(valueA, valueB, currentDirection)
    }],
    ['managementTypeId', 'Exit Mode', undefined],
    ['closeAt', 'Closed On', (a: IAutoTrade, b: IAutoTrade, currentDirection: "asc" | "desc") => {
      const valueA = `${a.closeAt || ''}`;
      const valueB = `${b.closeAt || ''}`;
      return TradeModel.compareHelper(valueA, valueB, currentDirection)
    }],
    ['statusId', 'Status', undefined]
  ].map((fields) => {
    const [name, title, comparator] = fields;
    return {
      name,
      title,
      comparator
    } as TableColumn
  });

  static getOpenedFilterFromPreset(presetDateRangeFilter: PresetDateRange | undefined) {
    if (!presetDateRangeFilter) {
      return({ startTime: undefined, endTime: undefined });
    }

    if (presetDateRangeFilter?.toString() === PresetDateRange.TODAY.toString()) {
      return({ startTime: StockHelper.fullHours().start.getTimeSec(), endTime: StockHelper.fullHours().end.getTimeSec() });
    }

    if (presetDateRangeFilter?.toString() === PresetDateRange.YESTERDAY.toString()) {
      const yesterday = StockHelper.findPreviousTradingDay(new Date());
      return({
        startTime: StockHelper.fullHours(yesterday).start.getTimeSec(),
        endTime: StockHelper.fullHours(yesterday).end.getTimeSec()
      });
    }

    if (presetDateRangeFilter?.toString() === PresetDateRange.THIS_WEEK.toString()) {
      const monday = Helper.getStartDateOfWeek(1, new Date());
      const friday = Helper.getStartDateOfWeek(5, new Date());
      return({ startTime: StockHelper.fullHours(monday).start.getTimeSec(), endTime: StockHelper.fullHours(friday).end.getTimeSec() });
    }

    if (presetDateRangeFilter?.toString() === PresetDateRange.LAST_WEEK.toString()) {
      const monday = Helper.getStartDateOfWeek(1, new Date(), 1);
      const friday = Helper.getStartDateOfWeek(5, new Date(), 1);
      return({ startTime: StockHelper.fullHours(monday).start.getTimeSec(), endTime: StockHelper.fullHours(friday).end.getTimeSec() });
    }

    if (presetDateRangeFilter?.toString() === PresetDateRange.THIS_MONTH.toString()) {
      const startOfMonth = Helper.getFirstOfMonth();
      const lastOfMonth = Helper.getLastDateOfMonth();
      return({ startTime: StockHelper.fullHours(startOfMonth).start.getTimeSec(), endTime: StockHelper.fullHours(lastOfMonth).end.getTimeSec() });
    }    
  }

}